import { useState } from 'react';
import { Animated, Platform } from 'react-native';
export function useAnimateTimming(props) {
    const { fromVal, toVal, duration: outerDuration, useNativeDriver = true, } = props || {};
    const [animatedVal] = useState(new Animated.Value(fromVal));
    function run(toValue, duration) {
        return new Promise((resolve) => {
            var _a;
            Animated.timing(animatedVal, {
                toValue: toValue !== null && toValue !== void 0 ? toValue : toVal,
                duration: (_a = duration !== null && duration !== void 0 ? duration : outerDuration) !== null && _a !== void 0 ? _a : 200,
                useNativeDriver: Platform.OS !== 'web' ? useNativeDriver : false,
            }).start((res) => {
                resolve(res);
            });
        });
    }
    return {
        opacity: animatedVal,
        animatedVal,
        runTiming: run,
        fadeIn: () => run(1),
        fadeOut: () => run(0),
    };
}
export function useAnimateSpring(props) {
    const { fromVal, toVal, useNativeDriver = true } = props || {};
    const [animatedVal] = useState(new Animated.Value(fromVal));
    function run(toValue) {
        return new Promise((resolve) => {
            Animated.spring(animatedVal, {
                toValue: toValue !== null && toValue !== void 0 ? toValue : toVal,
                speed: 100,
                useNativeDriver: Platform.OS !== 'web' ? useNativeDriver : false,
            }).start((res) => {
                resolve(res);
            });
        });
    }
    return {
        animatedVal,
        runTiming: run,
    };
}
